
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TradeTypes } from '../../../services/globals.service';
import { JobDataService } from '../../../services/job-data.service';
import { MetaDataService } from '../../../services/meta-data.service';
//import { MetaDataService, TriageQuestion, TriageQuestionData, JobType, FAQItem } from '../services/meta-data.service';

@Component({
  selector: 'triage-question-free-text',
  templateUrl: './triage-question-free-text.component.html',
  styleUrls: ['./triage-question-free-text.component.css', './../../../triage/triage.component.css']
})
export class TriageQuestionFreeTextComponent implements OnInit {

  public currentJobTypeIndex: number = 0;

  @Input() answer: string;
  @Output() answerChange = new EventEmitter<string>();
  
  @Output() toggleLocksmithPopupEvent = new EventEmitter<boolean>();
  @Output() togglecommonHVACMaintenaceJobsPopupEvent = new EventEmitter<boolean>();
  @Output() togglecommonHVACRepairJobsPopupEvent = new EventEmitter<boolean>();
  @Output() toggleHealthyHomesInfoPopupEvent = new EventEmitter<boolean>();
  

  constructor(
    public jobDataService: JobDataService,
    public tradeTypes: TradeTypes,
    public metaDataService: MetaDataService,
  ) { }

  ngOnInit() {
  }
  
  public answerChanged() {
    this.answerChange.emit(this.answer);
  }
  
  public toggleLocksmithPopup(on: boolean): void {
    this.toggleLocksmithPopupEvent.emit(on);
  }

  public togglecommonHVACMaintenaceJobsPopup(on: boolean): void {
    this.togglecommonHVACMaintenaceJobsPopupEvent.emit(on);
  }

  public togglecommonHVACRepairJobsPopup(on: boolean): void {
    this.togglecommonHVACRepairJobsPopupEvent.emit(on);
  }

  public toggleHealthyHomesInfoPopup(on: boolean): void {
    this.toggleHealthyHomesInfoPopupEvent.emit(on);
  }

}
